<router-outlet></router-outlet>

<ng-template #confirmtemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Confirm deletion</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeConfirmRemoveDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="text-start">Confirm deletion? This operation can not be undone</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn at-ct-btn-ib-white-with-dark-bg" (click)="closeConfirmRemoveDialog()">Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmSubEntityDeletion()">Confirm deletion</button>
  </div>
</ng-template>

<a [routerLink]="getCreatSubLink()">
  <i class="fas fa-plus mouse-pointer"></i> Add new attributes type
</a>


<table mat-table [dataSource]="attributgroupe" matSort>

  <ng-container *ngFor="let column of displayedColumns">

    <ng-container *ngIf="column!=='delete'" matColumnDef="{{column}}">
      <th mat-header-cell class="pl-2 pr-2" *matHeaderCellDef mat-sort-header>{{column}}</th>
      <td mat-cell *matCellDef="let element">
        <div class="ms-2 me-2">
          <ng-container *ngIf="isKeyColumn(column)">
            <a [routerLink]="getEditSubLink(element['id'])">{{element[column]}}</a>
          </ng-container>
          <ng-container *ngIf="!isKeyColumn(column)">
            {{element[column]}}
          </ng-container>
        </div>
      </td>
    </ng-container>

    <ng-container *ngIf="column==='delete'" matColumnDef="{{column}}">
      <th mat-header-cell class="pl-2 pr-2" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <i class="far fa-trash-alt mouse-pointer" (click)="confirmRemoveDialog(confirmtemplate, element['id'])"></i>
      </td>
    </ng-container>

  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
